// La columna de configuración del modo "Prompt libre" en DESKTOP —
// ADR-2026-09-07-modo-prompt-libre.
//
// Misma anatomía que `PanelCompacto` (Modelo) y `PanelCatalogoCompacto` (Fotos de
// producto): la columna en DOS piezas, lo que scrollea arriba y el pie fijo abajo
// (`PieConfiguracionModo`, ADR-2026-09-06-el-pie-de-configuracion-es-un-componente).
// Lo que cambia es QUÉ se elige: acá no hay producto obligatorio, modelo ni pose — hay
// un prompt, y referencias opcionales que se suman con las tres cards del asistente.
//
// El pie es el de Modelo tal cual: Calidad · Formato en una fila, y abajo la cantidad
// pegada al Generar con su pastilla de créditos.

import React from 'react';
import { type CalidadImagen } from '../../components/AjustesRapidosProducto';
import { PieConfiguracionModo } from '../../components/PieConfiguracionModo';
import { CardsDeReferencia } from '../shared/CardsDeReferencia';
import { PromptBoxLibre, type PromptBoxLibreProps } from './PromptBoxLibre';
import { MAX_CANTIDAD } from './promptLibre';

export interface PanelPromptLibreProps {
  box: PromptBoxLibreProps;

  onAddProduct: () => void;
  onAddModel: () => void;
  onUploadImage: () => void;

  calidad: CalidadImagen;
  onCalidadChange: (v: CalidadImagen) => void;
  formatoLabel: string;
  onOpenFormato: () => void;
  cantidad: number;
  onCantidadChange: (v: number) => void;

  /** Créditos de la tanda: la pastilla del botón. */
  creditos: number;
  onGenerate: () => void;
  /** Qué falta para poder generar (apaga el botón). */
  falta?: string;
}

export const PanelPromptLibre: React.FC<PanelPromptLibreProps> = ({
  box,
  onAddProduct,
  onAddModel,
  onUploadImage,
  calidad,
  onCalidadChange,
  formatoLabel,
  onOpenFormato,
  cantidad,
  onCantidadChange,
  creditos,
  onGenerate,
  falta,
}) => (
  /* `h-full min-h-0`: el alto lo pone el contenedor de afuera. Sin `min-h-0` el
     scroller no puede achicarse y el pie se va de la vista (flex + overflow). */
  <div className="h-full min-h-0 flex flex-col">
    <div className="flex-1 min-h-0 overflow-y-auto flex flex-col gap-4 pb-4">
      <PromptBoxLibre {...box} />

      {/* Las tres cards, en la grilla de escritorio. Lo ya elegido no se muestra acá:
          se ve como chips adentro de la caja.

          Este panel SÓLO se monta en desktop, y hasta el 2026-09-09 la pieza que dibujaba
          esto era `AccionCardsRow`, del asistente. Ese día pasó a ser sólo mobile y este
          bloque quedó dibujando NADA: el rótulo de acá arriba con el vacío debajo, y sin
          ninguna otra forma de adjuntar (la caja de este modo no tiene "+") —
          ADR-2026-09-13-las-cards-de-referencia-de-escritorio-vuelven-como-pieza-de-los-modos. */}
      <div>
        <p className="text-[12.5px] font-medium text-[#3C3C43]/55 mb-2">
          Referencias (opcional)
        </p>
        <CardsDeReferencia
          onAddProduct={onAddProduct}
          onAddModel={onAddModel}
          onUploadImage={onUploadImage}
          uploading={box.subiendo}
          // Sin tope de ancho: acá la grilla ocupa la columna de configuración, que ya es
          // angosta (el default de 680px es el ancho de la caja del asistente).
          className="w-full"
        />
      </div>
    </div>

    <PieConfiguracionModo
      calidad={calidad}
      onCalidadChange={onCalidadChange}
      formatoLabel={formatoLabel}
      onOpenFormato={onOpenFormato}
      contador={{ valor: cantidad, max: MAX_CANTIDAD, onChange: onCantidadChange }}
      imagenesDeLaTanda={cantidad}
      creditCost={creditos}
      onGenerate={onGenerate}
      falta={falta}
    />
  </div>
);

export default PanelPromptLibre;
